// Models
export var CopyMoveCustomizerMode;
(function(CopyMoveCustomizerMode) {
    /** Copy task */ CopyMoveCustomizerMode[CopyMoveCustomizerMode["Copy"] = 0] = "Copy";
    /** Move task */ CopyMoveCustomizerMode[CopyMoveCustomizerMode["Move"] = 1] = "Move";
})(CopyMoveCustomizerMode || (CopyMoveCustomizerMode = {}));
